// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__356dd","col":"styles_col__h-_LK","actions":"styles_actions__36tJc","conflict":"styles_conflict__UpnjH"};